import { Route } from '@angular/router';

/** Day-to-day postings: purchase, sales, marketplace, returns, payments, stock. */
export const transactionsChildren: Route[] = [
  {
    path: 'purchase',
    loadChildren: () =>
      import('app/modules/transactions/purchase/purchase.module').then((m) => m.PurchaseModule),
  },
  {
    path: 'sales',
    loadChildren: () => import('app/modules/transactions/sales/sales.module').then((m) => m.SalesModule),
    data: { permission: 'transactions.sale.transaction' },
  },
  {
    path: 'marketplace',
    loadChildren: () =>
      import('app/modules/transactions/marketplace-integration/marketplace-integration.module').then(
        (m) => m.MarketplaceIntegrationModule,
      ),
  },
  {
    path: 'purchase-return',
    loadChildren: () =>
      import('app/modules/transactions/purchase-return/purchase-return.module').then(
        (m) => m.PurchaseReturnModule,
      ),
  },
  {
    path: 'payment-to-suppliers',
    loadChildren: () =>
      import('app/modules/transactions/payments/supplier-payment/supplier-payment.module').then(
        (m) => m.SupllierPaymentModule,
      ),
  },
  {
    path: 'customer-receipts',
    loadChildren: () =>
      import('app/modules/transactions/payments/customer-receipt/customer-receipt.module').then(
        (m) => m.CustomerReceiptModule,
      ),
  },
  {
    path: 'sales-return',
    loadChildren: () =>
      import('app/modules/transactions/sales-return/sales-return.module').then((m) => m.SalesReturnModule),
  },
  {
    path: 'stock-adjustment',
    loadChildren: () =>
      import('app/modules/transactions/stock-adjustment/stock-adjustment.routes').then(
        (m) => m.stockAdjustmentRoutes,
      ),
  },
  {
    path: 'purchase-order-summary',
    loadComponent: () =>
      import('app/modules/transactions/purchase-order-summary/purchase-order-summary.component').then(
        (m) => m.PurchaseOrderSummaryComponent,
      ),
  },
];
